import { twMerge } from "@/utils/twMerge";

import type { ComponentProps } from "react";

export function UnreadDot({ className, ...rest }: ComponentProps<"div">) {
  return (
    <div
      className={twMerge(
        "flex min-w-[6px] min-h-[6px] rounded-full bg-rose-500 pointer-events-none",
        className,
      )}
      {...rest}
    />
  );
}
